export default function () {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7109_11803)">
                <path
                    d="M32.625 26.625L32.625 8.25C32.625 7.42157 31.9534 6.75 31.125 6.75L4.875 6.75C4.04657 6.75 3.375 7.42157 3.375 8.25L3.375 26.625C3.375 27.4534 4.04657 28.125 4.875 28.125L31.125 28.125C31.9534 28.125 32.625 27.4534 32.625 26.625Z"
                    stroke="#3EAE60"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M29.25 17L29.25 11.125C29.25 10.5727 28.8023 10.125 28.25 10.125L7.75 10.125C7.19772 10.125 6.75 10.5727 6.75 11.125L6.75 17C6.75 17.5523 7.19772 18 7.75 18L28.25 18C28.8023 18 29.25 17.5523 29.25 17Z"
                    stroke="#3EAE60"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="18" cy="24.75" r="1.125" fill="#3EAE60" />
                <path
                    d="M23.625 24.75C23.625 25.0607 23.3732 25.3125 23.0625 25.3125C22.7518 25.3125 22.5 25.0607 22.5 24.75C22.5 24.4393 22.7518 24.1875 23.0625 24.1875C23.3732 24.1875 23.625 24.4393 23.625 24.75Z"
                    fill="#3EAE60"
                />
                <path
                    d="M28.125 24.75C28.125 25.0607 27.8732 25.3125 27.5625 25.3125C27.2518 25.3125 27 25.0607 27 24.75C27 24.4393 27.2518 24.1875 27.5625 24.1875C27.8732 24.1875 28.125 24.4393 28.125 24.75Z"
                    fill="#3EAE60"
                />
                <path
                    d="M14.0625 24.75C14.0625 25.0607 13.8107 25.3125 13.5 25.3125C13.1893 25.3125 12.9375 25.0607 12.9375 24.75C12.9375 24.4393 13.1893 24.1875 13.5 24.1875C13.8107 24.1875 14.0625 24.4393 14.0625 24.75Z"
                    fill="#3EAE60"
                />
                <path
                    d="M9 24.75C9 25.0607 8.74816 25.3125 8.4375 25.3125C8.12684 25.3125 7.875 25.0607 7.875 24.75C7.875 24.4393 8.12684 24.1875 8.4375 24.1875C8.74816 24.1875 9 24.4393 9 24.75Z"
                    fill="#3EAE60"
                />
                <path d="M11.25 12.375V15.75" stroke="#3EAE60" strokeLinecap="round" />
                <path d="M18 12.375V15.75" stroke="#3EAE60" strokeLinecap="round" />
                <path d="M24.75 12.375V15.75" stroke="#3EAE60" strokeLinecap="round" />
                <path d="M21.375 12.375V15.75" stroke="#3EAE60" strokeLinecap="round" />
                <path d="M14.625 12.375V15.75" stroke="#3EAE60" strokeLinecap="round" />
                <line x1="3.375" y1="21.75" x2="32.625" y2="21.75" stroke="#3EAE60" strokeWidth="1.5" />
            </g>
            <defs>
                <clipPath id="clip0_7109_11803">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
